export const DOCUMENT_ACCEPT = [
  ".pdf",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".csv",
  ".txt",
].join(",");

export const MAX_CHAT_DOCUMENT_SIZE = 10 * 1024 * 1024;
export const MAX_CHAT_IMAGE_SIZE = 5 * 1024 * 1024;

const DOCUMENT_EXTENSIONS = new Set(
  DOCUMENT_ACCEPT.split(",").map((extension) => extension.slice(1))
);

export const getFileExtension = (fileName = "") => {
  const lastSegment = String(fileName).split(/[\\/]/).pop() || "";
  const extensionIndex = lastSegment.lastIndexOf(".");
  return extensionIndex > 0 ? lastSegment.slice(extensionIndex + 1).toLowerCase() : "";
};

export const sanitizeChatFileName = (fileName = "archivo") => {
  const baseName = String(fileName).split(/[\\/]/).pop() || "archivo";
  return baseName
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9._-]+/g, "_")
    .replace(/^_+|_+$/g, "") || "archivo";
};

export const validateChatAttachment = (file, attachmentKind) => {
  if (!file) return "Selecciona un archivo";

  if (attachmentKind === "image") {
    if (!String(file.type).toLowerCase().startsWith("image/")) {
      return "Selecciona un archivo de imagen válido";
    }
    if (file.size > MAX_CHAT_IMAGE_SIZE) {
      return "La imagen excede el límite de 5 MB";
    }
    return "";
  }

  const extension = getFileExtension(file.name);
  if (!DOCUMENT_EXTENSIONS.has(extension)) {
    return "Formato no permitido. Adjunta PDF, Word, Excel, CSV o TXT";
  }
  if (file.size > MAX_CHAT_DOCUMENT_SIZE) {
    return "El documento excede el límite de 10 MB";
  }

  return "";
};
